<template>
  <section>
    <!--工具条-->
    <el-col :span="24" class="toolbar">
      <el-form :inline="true" :model="filters" ref="filters">
        <el-form-item>
          <el-input v-model.trim="filters.roleName" placeholder="角色名"></el-input>
        </el-form-item>
        <el-form-item>
          <el-button type="primary" v-on:click="initT">查询</el-button>
        </el-form-item>
        <el-form-item>
          <el-button type="primary" v-if="buttonsAccess.indexOf('添加角色') > -1" @click="handleAdd">新增</el-button>
        </el-form-item>
      </el-form>
    </el-col>

    <!--列表-->
    <el-table :data="list" highlight-current-row v-loading="listLoading" style="width: 100%;">
      <el-table-column prop="roleName" width="150" label="角色名称">
      </el-table-column>
      <el-table-column prop="comments" width="150" label="备注">
      </el-table-column>
      <el-table-column prop="sysRbacUser.userName" label="创建人">
      </el-table-column>
      <el-table-column prop="status" label="状态">
        <template slot-scope="scope">
          <el-tag
            :type="scope.row.status === 1 ? 'success' : 'danger'"
            close-transition>{{formatterStatus(scope.row.status)}}
          </el-tag>
        </template>
      </el-table-column>
      <el-table-column prop="createTime" width="170" label="创建时间">
      </el-table-column>
      <el-table-column prop="updateTime" width="170" label="更新时间">
      </el-table-column>
      <el-table-column label="操作" width="300" fixed="right" v-if="buttonsAccess.indexOf('操作-修改') > -1 || buttonsAccess.indexOf('操作-修改状态') > -1 || buttonsAccess.indexOf('操作-资源管理') > -1">
        <template slot-scope="scope">
          <el-button size="mini" v-if="buttonsAccess.indexOf('操作-修改') > -1" @click="handleEdit(scope.$index, scope.row)">编辑</el-button>
          <el-button size="mini" type="danger" v-if="buttonsAccess.indexOf('操作-修改状态') > -1" @click="handleEditStatus(scope.$index, scope.row)">更改状态</el-button>
          <el-button size="mini" v-if="buttonsAccess.indexOf('操作-资源管理') > -1" @click="handleEditMenu(scope.$index, scope.row)">更改权限</el-button>
        </template>
      </el-table-column>
    </el-table>

    <!--工具条-->
    <el-col :span="24" class="toolbar">
      <el-pagination layout="prev, pager, next" @current-change="handleCurrentChange" :total="total"
                     :page-size="pageSize" :current-page="pageNum" style="float:right;">
      </el-pagination>
    </el-col>

    <!--新增界面-->
    <el-dialog title="新增" :visible.sync="addFormVisible" :close-on-click-modal="false">
      <el-form :model="addForm" :rules="addFormRules" ref="addForm" label-width="100px">
        <el-form-item label="角色名" prop="roleName" required>
          <el-input v-model="addForm.roleName" auto-complete="off"></el-input>
        </el-form-item>
        <el-form-item label="备注信息" prop="comments">
          <el-input v-model="addForm.comments" auto-complete="off"></el-input>
        </el-form-item>
      </el-form>
      <div slot="footer" class="dialog-footer">
        <el-button @click.native="addFormVisible = false">取消</el-button>
        <el-button type="primary" @click="addSubmit('addForm')" :loading="addLoading">提交</el-button>
      </div>
    </el-dialog>

    <!--编辑界面-->
    <el-dialog title="编辑" :visible.sync="editFormVisible" :close-on-click-modal="false">
      <el-form :model="editForm" :rules="editFormRules" ref="editForm" label-width="100px">
        <el-form-item label="角色名" prop="roleName" required>
          <el-input v-model="editForm.roleName" auto-complete="off"></el-input>
        </el-form-item>
        <el-form-item label="备注信息" prop="comments">
          <el-input v-model="editForm.comments" auto-complete="off"></el-input>
        </el-form-item>
      </el-form>
      <div slot="footer" class="dialog-footer">
        <el-button @click.native="editFormVisible = false">取消</el-button>
        <el-button type="primary" @click="editSubmit('editForm')" :loading="editLoading">提交</el-button>
      </div>
    </el-dialog>

    <!--权限界面-->
    <el-dialog title="权限设置" :visible.sync="menuVisible" :close-on-click-modal="false">
      <el-tabs v-model="activeName" >
        <el-tab-pane label="菜单权限" name="first">
          <el-tree
                  :data="menuTree"
                  show-checkbox
                  default-expand-all
                  :default-checked-keys="defaultCheckedKeys"
                  node-key="id"
                  check-strictly
                  :props="defaultProps"
                  ref="menuTree">
          </el-tree>
        </el-tab-pane>
        <el-tab-pane label="数据权限" name="second">
          <el-checkbox-group v-model="consultChecked">
            <el-checkbox v-for="consult in consultReturn"  :label="consult.id" :key="consult.id"  border style="width:50%;margin: 8px 0px;">{{consult.name}}</el-checkbox>
          </el-checkbox-group>
        </el-tab-pane>
      </el-tabs>
      <div slot="footer" class="dialog-footer">
        <el-button @click.native="menuVisible = false">取消</el-button>
        <el-button type="primary" @click="editMenu" :loading="editLoading">提交</el-button>
      </div>
    </el-dialog>
  </section>
</template>

<script>
  import {
    getRoleListPage,
    saveRole,
    updateRole,
    queryListMenu,
    updateMenu,
    getConsultList,
    roleDataAccessList
  } from '../../api/api';

  export default {
    data() {
      return {
        consultChecked:[],
        consultReturn :[],
        activeName:'first',
        //按钮权限
        buttonsAccess:this.$storejs.get(process.env.VUE_APP_APPKEY+"userAccess")[this.$route.meta.id]?this.$storejs.get(process.env.VUE_APP_APPKEY+"userAccess")[this.$route.meta.id].buttons:[],
        //列表
        filters: {
          roleName: ''
        },
        list: [],
        total: 0,
        pageNum: 1,
        pageSize: 10,
        listLoading: false,
        //新增界面
        addFormVisible: false,//新增界面是否显示
        addLoading: false,
        addFormRules: {
          userRole: [
            {required: true, message: '请输入角色名', trigger: 'blur'},
            {min: 4, max: 10, message: '长度在 4 到 20 个字符', trigger: 'blur'}
          ]
        },
        addForm: {
          roleName: '',
          comments: ''
        },
        //编辑界面
        editFormVisible: false,//编辑界面是否显示
        editLoading: false,
        editFormRules: {
          userRole: [
            {required: true, message: '请输入角色名', trigger: 'blur'},
            {min: 4, max: 10, message: '长度在 4 到 20 个字符', trigger: 'blur'}
          ]
        },
        editForm: {
          id: 0,
          roleName: '',
          comments: ''
        },
        //菜单权限
        menuVisible: false,//菜单权限界面是否显示
        menuTree:[],
        editMenuTreeId:0,
        defaultProps: {
          children: 'children',
          label: 'menuName'
        },
        defaultCheckedKeys: []
      }
    },
    methods: {
      /*查询资讯分类*/
      getConsult(){
          getConsultList().then((response)=> {
              this.consultReturn = response.data.data;
          })
      },
      initT() {
        let para = {
          pageNum: this.pageNum,
          pageSize: this.pageSize,
          roleName: this.filters.roleName.toString().trim()
        };
        this.listLoading = true;
        getRoleListPage(para).then((res) => {
          this.total = res.data.data.total;
          this.list = res.data.data.list;
          this.listLoading = false;
        });
      },
      handleCurrentChange(val) {
        this.pageNum = val;
        this.initT();
      },
      formatterStatus(val) {
        return val === 1 ? '正常' : '已删除';
      },
      //显示新增界面
      handleAdd: function () {
        this.addFormVisible = true;
        if (this.$refs['addForm']) {
          this.resetForm('addForm')
        }
      },
      //新增
      addSubmit: function () {
        this.$refs.addForm.validate((valid) => {
          if (valid) {
            this.$confirm('确认提交吗？', '提示', {}).then(() => {
              this.addLoading = true;
              let formData = new FormData();
              formData.append('roleName', this.addForm.roleName);
              formData.append('comments', this.addForm.comments);
//              for (var [key, value] of formData.entries()) {
//                console.log(key, value);
//              }
              saveRole(formData).then((res) => {
                this.addLoading = false;
                if (res.data.status == 200) {
                  this.$notify({
                    title: '成功',
                    message: '提交成功',
                    type: 'success'
                  });
                  this.addFormVisible = false;
                  this.$refs['addForm'].resetFields();
                  this.initT();
                } else {
                  this.$notify({
                    title: '失败',
                    message: res.data.msg,
                    type: 'error'
                  });
                }
              });
            });
          }
        });
      },
      //显示编辑界面
      handleEdit: function (index, row) {
        if (row.id == 1) {
          this.$notify({
            title: '警告',
            message: '管理员不可更改！',
            type: 'warning'
          });
        } else {
          this.editFormVisible = true;
          this.editForm = {
            id: row.id,
            roleName: row.roleName,
            comments: row.comments
          }
        }
      },
      //编辑
      editSubmit: function () {
        this.$refs.editForm.validate((valid) => {
          if (valid) {
            this.$confirm('确认提交吗？', '提示', {}).then(() => {
              this.editLoading = true;
              let formData = new FormData();
              formData.append('id', this.editForm.id);
              formData.append('roleName', this.editForm.roleName);
              formData.append('comments', this.editForm.comments);
              updateRole(formData).then((res) => {
                this.editLoading = false;
                if (res.data.status == 200) {
                  this.$notify({
                    title: '成功',
                    message: '提交成功',
                    type: 'success'
                  });
                  this.editFormVisible = false;
                  this.$refs['editForm'].resetFields();
                  this.initT();
                } else {
                  this.$notify({
                    title: '失败',
                    message: res.data.msg,
                    type: 'error'
                  });
                }
              });
            });
          }
        });
      },
      handleEditStatus: function (index, row) {
        if (row.id == 1) {
          this.$notify({
            title: '警告',
            message: '管理员不可更改！',
            type: 'warning'
          });
        } else {
          let formData = new FormData();
          formData.append('id', row.id);
          if (row.status === 1) {
            formData.append('status', 0);
          } else {
            formData.append('status', 1);
          }
          updateRole(formData).then((res) => {
            if (res.data.status == 200) {
              this.$notify({
                title: '成功',
                message: '修改成功',
                type: 'success'
              });
              this.initT();
            } else {
              this.$notify({
                title: '失败',
                message: res.data.msg,
                type: 'error'
              });
            }
          });
        }
      },
      handleEditMenu: function (index, row) {
        if (row.id == 1) {
          this.$notify({
            title: '警告',
            message: '管理员不可更改！',
            type: 'warning'
          });
        } else {
          let para = {
            roleId: row.id
          };
          this.editMenuTreeId=row.id
          queryListMenu(para).then((res) => {
            this.menuVisible = true;
            this.menuTree = res.data.data.treeList;
            this.defaultCheckedKeys = res.data.data.defaultCheckedKeys;
          });
          let formData = new FormData();
          formData.append('roleId', this.editMenuTreeId);
          roleDataAccessList(formData).then((res) => {
              this.consultChecked=res.data.data.roleDataAccessList;
          });
        }
      },
      editMenu: function () {
        let menus=this.$refs.menuTree.getCheckedKeys()
        if(menus.length>0){
            let formData = new FormData();
            formData.append('menuIds', menus);
            formData.append('consultList', this.consultChecked);
            formData.append('roleId', this.editMenuTreeId);
            updateMenu(formData).then((res) => {
                if(res.data.status == 200){
                    this.$notify({
                        title: '成功',
                        message: '修改成功',
                        type: 'success'
                    });
                    this.menuVisible = false;
                    this.initT();
                }else{
                    this.$notify({
                        title: '失败',
                        message: '修改失败',
                        type: 'fail'
                    });
                }
            });
        }else{
            this.$notify({
                title: '失败',
                message: '请选择菜单',
                type: 'fail'
            });
        }
      },
      resetForm(formName) {
        this.$refs[formName].resetFields();
      }
    },
    mounted() {
      this.initT();
      this.getConsult();
    }
  }
</script>

<style scoped>

</style>
